module.exports = require('./$.hide');


//////////////////
// WEBPACK FOOTER
// ./~/react-async-script/~/core-js/library/modules/$.redefine.js
// module id = 719
// module chunks = 0